/* 100X Equine — customer photo wall interaction layer.
   The tiles themselves are BAKED into the section markup (static, curated, on
   Shopify's CDN). This file does not fetch anything at runtime: no third-party
   API call, no external images, nothing to go stale mid-pageview. The pull +
   curation tooling lives in scratchpad/loox_pull.py and is run on demand.

   ONE REVIEW = ONE TILE. A review with several photos keeps them together as a
   set: the tile shows the first with a count badge, and the lightbox pages
   through the rest with arrows, keyboard, or swipe.

   Expected tile markup (emitted by the bake):
     <figure class="gx-wall-tile" role="button" tabindex="0"
             data-lb-photos="url1|url2|url3"   full-size, pipe separated
             data-lb-rating data-lb-name data-lb-date
             data-lb-verified data-lb-body data-lb-product>
       <img src="tile.jpg" alt="..."><span class="gx-tile-count">3</span>
     </figure> */
(function () {
  // one init per page, even if two sections both request the file
  if (window.__gxWallInit) return;
  window.__gxWallInit = true;

  var walls = document.querySelectorAll('[data-gx-ugc]');
  if (!walls.length) return;

  var SID = 'gx-loox-wall-style';
  if (!document.getElementById(SID)) {
    var st = document.createElement('style');
    st.id = SID;
    st.textContent =
      '.gx-wall-tile{position:relative}' +
      '.gx-tile-count{position:absolute;right:6px;bottom:6px;background:rgba(0,0,0,.62);' +
      '  color:#fff;font:600 10px/1 system-ui,sans-serif;padding:4px 6px;border-radius:4px;' +
      '  pointer-events:none;display:flex;align-items:center;gap:3px}' +
      '.gx-tile-count::before{content:"";width:7px;height:7px;border:1.2px solid #fff;' +
      '  border-radius:1px;box-shadow:2px -2px 0 -1px #fff}' +
      '.gx-wall-lb-fig{max-width:min(92vw,880px)}' +
      '.gx-lb-stage{position:relative;display:flex;align-items:center;justify-content:center}' +
      '.gx-lb-nav{position:absolute;top:50%;transform:translateY(-50%);width:40px;height:40px;' +
      '  border:0;border-radius:50%;background:rgba(0,0,0,.55);color:#fff;font-size:20px;' +
      '  cursor:pointer;display:none;align-items:center;justify-content:center;z-index:2}' +
      '.gx-lb-nav:hover{background:rgba(0,0,0,.8)}' +
      '.gx-lb-nav[data-dir="prev"]{left:8px}.gx-lb-nav[data-dir="next"]{right:8px}' +
      '.gx-lb-multi .gx-lb-nav{display:flex}' +
      '.gx-lb-counter{display:none;margin-top:8px;font:600 12px/1 system-ui,sans-serif;' +
      '  color:rgba(255,255,255,.7);text-align:center}' +
      '.gx-lb-multi .gx-lb-counter{display:block}' +
      '.gx-lb-review{margin-top:14px;text-align:left;color:#fff}' +
      '.gx-lb-review .lb-top{display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-bottom:8px}' +
      '.gx-lb-review .lb-stars{color:#ffb400;letter-spacing:1px;font-size:15px}' +
      '.gx-lb-review .lb-name{font-weight:700;font-size:14px}' +
      '.gx-lb-review .lb-verified{font-size:11px;font-weight:600;color:#7ddb9a;' +
      '  border:1px solid rgba(125,219,154,.45);border-radius:999px;padding:2px 8px;white-space:nowrap}' +
      '.gx-lb-review .lb-since{font-size:12px;color:rgba(255,255,255,.62);font-weight:500}' +
      '.gx-lb-review .lb-body{font-size:14px;line-height:1.55;color:rgba(255,255,255,.88);' +
      '  max-height:34vh;overflow-y:auto;margin:0}' +
      '.gx-lb-review .lb-prod{margin-top:10px;font-size:12px;color:rgba(255,255,255,.55)}' +
      '@media (max-width:700px){.gx-lb-review .lb-body{max-height:26vh;font-size:13.5px}' +
      '  .gx-lb-nav{width:34px;height:34px;font-size:17px}}';
    document.head.appendChild(st);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function stars(n) {
    n = Math.max(0, Math.min(5, Math.round(n || 0)));
    return '★'.repeat(n) + '☆'.repeat(5 - n);
  }
  // Tenure arrives already computed, as "Customer for 4+ years". It is resolved offline by
  // joining each review to its Shopify order and reading the customer's genuine FIRST order
  // date, gated at 2+ lifetime orders so "customer" always means somebody who came back, and
  // floored at 2 years so no badge reads weakly. Deliberately no date anywhere: a date makes
  // the wall look stale a week after any refresh, a duration strengthens with age.

  walls.forEach(function (sec) {
    // The marquee needs each track duplicated so translateX(-50%) loops seamlessly. The
    // section emits its tiles ONCE and the copy is made here, because every tile carries its
    // full review text in data attributes and inlining all of that twice would roughly double
    // the section's HTML for no benefit. If this script fails the wall still renders, it just
    // does not loop cleanly.
    sec.querySelectorAll('.gx-wall-track').forEach(function (trk) {
      if (trk.dataset.gxLooped) return;
      trk.dataset.gxLooped = '1';
      Array.prototype.slice.call(trk.children).forEach(function (c) {
        var clone = c.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        trk.appendChild(clone);
      });
    });

    var lb = sec.querySelector('[data-gx-lb]');
    var fig = sec.querySelector('.gx-wall-lb-fig');
    var lbImg = sec.querySelector('[data-gx-lb-img]');
    var lbCap = sec.querySelector('[data-gx-lb-cap]');
    if (!lb || !fig || !lbImg || !lbCap) return;

    // upgrade the lightbox once: wrap the image in a stage with prev/next + counter
    var stage = fig.querySelector('.gx-lb-stage');
    if (!stage) {
      stage = document.createElement('div');
      stage.className = 'gx-lb-stage';
      lbImg.parentNode.insertBefore(stage, lbImg);
      stage.appendChild(lbImg);
      ['prev', 'next'].forEach(function (dir) {
        var b = document.createElement('button');
        b.className = 'gx-lb-nav';
        b.setAttribute('data-dir', dir);
        b.setAttribute('aria-label', dir === 'prev' ? 'Previous photo' : 'Next photo');
        b.innerHTML = dir === 'prev' ? '&#8249;' : '&#8250;';
        stage.appendChild(b);
      });
      var c = document.createElement('div');
      c.className = 'gx-lb-counter';
      stage.parentNode.insertBefore(c, stage.nextSibling);
    }
    var counter = fig.querySelector('.gx-lb-counter');

    var photos = [], idx = 0;

    function show(i) {
      if (!photos.length) return;
      idx = (i + photos.length) % photos.length;
      lbImg.src = photos[idx];
      if (counter) counter.textContent = (idx + 1) + ' / ' + photos.length;
    }
    function open(t) {
      var raw = t.getAttribute('data-lb-photos') || t.getAttribute('data-lb-src') || '';
      photos = raw.split('|').filter(Boolean);
      if (!photos.length) return;
      lb.classList.toggle('gx-lb-multi', photos.length > 1);
      lbImg.alt = t.getAttribute('data-lb-cap') || '';
      show(0);

      var rating = t.getAttribute('data-lb-rating');
      var body = t.getAttribute('data-lb-body');
      var name = t.getAttribute('data-lb-name');
      var ver = t.getAttribute('data-lb-verified');
      var prod = t.getAttribute('data-lb-product');
      var tenure = t.getAttribute('data-lb-tenure') || '';
      if (rating || body) {
        lbCap.innerHTML =
          '<div class="gx-lb-review"><div class="lb-top">' +
            (rating ? '<span class="lb-stars">' + stars(Number(rating)) + '</span>' : '') +
            (name ? '<span class="lb-name">' + esc(name) + '</span>' : '') +
            (ver ? '<span class="lb-verified">✓ Verified buyer</span>' : '') +
            (tenure ? '<span class="lb-since">' + esc(tenure) + '</span>' : '') +
          '</div>' +
          (body ? '<p class="lb-body">' + esc(body) + '</p>' : '') +
          // plain product name only. The stored Loox name is the Shopify TITLE frozen at review
          // time and used to carry promo suffixes ("Gut X » up to 63% Off"), plus Amino-MAX
          // reviews written while it was still called Regen-X. The bake writes the page's own
          // product name here, so this just prints it.
          (prod ? '<div class="lb-prod">' + esc(prod) + '</div>' : '') +
          '</div>';
      } else {
        lbCap.textContent = t.getAttribute('data-lb-cap') || '';
      }
      lb.style.display = '';
    }
    function close() {
      lb.style.display = 'none';
      lbImg.removeAttribute('src');
      lbCap.textContent = '';
      lb.classList.remove('gx-lb-multi');
      photos = [];
    }
    var isOpen = function () { return lb.style.display !== 'none' && photos.length; };

    sec.querySelectorAll('.gx-wall-tile').forEach(function (t) {
      t.addEventListener('click', function () { open(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(t); }
      });
    });

    lb.addEventListener('click', function (e) {
      var nav = e.target.closest && e.target.closest('.gx-lb-nav');
      if (nav) { e.stopPropagation(); show(idx + (nav.getAttribute('data-dir') === 'next' ? 1 : -1)); return; }
      if (e.target === lb || e.target.hasAttribute('data-gx-lb-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
    });

    // swipe on touch
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 == null || photos.length < 2) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  });
})();
